import { Ticket } from "../../types";
import DetailDrawer from "../shared/DetailDrawer";
import TicketDetailContent from "./TicketDetailContent";

interface TicketDetailPanelProps {
  ticket: Ticket | null;
  open: boolean;
  onClose: () => void;
}

export default function TicketDetailPanel({
  ticket,
  open,
  onClose,
}: TicketDetailPanelProps) {
  return (
    <DetailDrawer open={open} onClose={onClose} contentKey={ticket?.id}>
      {ticket && (
        <TicketDetailContent
          ticket={ticket}
          onClose={onClose}
          layout="drawer"
        />
      )}
    </DetailDrawer>
  );
}
